<div class="live-panel-title mt-2">
  Active Tracking <small>{{ total }}</small>
</div>
<div style="margin-top: 10px;"></div>

<div id="trackingTab">
  <ul class="nav nav-tabs custom-tabs">
    <li [class.active]="showActive">
      <a  [class.active]="showActive" (click)="setShowActive()" >Active</a>
    </li>
    <!--
    <li class="nav-item">
      <a class="nav-link" [class.active]="showMissed" (click)="setShowMissed()">Missed</a>
    </li>
    -->
    <li [class.active]="showDistress">
      <a (click)="setShowDistress()">Distress</a>
    </li>
  </ul>

  @if (showActive) {
    <div style="position: absolute;" id="active" class="tab-pane fade show active">
      <div style="padding-bottom: 120px; padding-right: 10px;">
        <table class="table table-striped table-hover custom-table" style="padding-top: 10px;">
          <tbody>
            @for (item of active_tracking_items; track item) {
              <tr (click)="activeTrackingEventClick(item)">
                <td>
                  <div class="row">
                    <div class="col-lg-12">
                      <h4>{{ item.title }}</h4>
                      <p>{{ item.getFormattedDate() }}</p>
                    </div>
                  </div>
                </td>
                <td>
                  <button type="button" class="btn btn-info" (click)="viewActiveTrackingEvent($event, item)">
                    <i class="glyphicon glyphicon-info-sign"></i>
                  </button>
                </td>
                <td>
                  <button type="button" class="btn btn-danger" (click)="goLive($event, item)">
                    <i class="glyphicon glyphicon-globe"></i>
                  </button>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
  }

  @if (showMissed) {
    <div style="position: absolute;" id="missed" class="tab-pane fade">
      <div style="padding-bottom: 120px; padding-right: 10px;">
        <table class="table table-striped table-hover custom-table" style="padding-top: 10px;">
          <tbody>
            @for (item of missed_tracking_items; track item) {
              <tr (click)="activeTrackingEventClick(item)">
                <td>
                  <div class="row">
                    <div class="col-lg-12">
                      <h4>{{ item.title }}</h4>
                      <p>{{ item.getFormattedDate() }}</p>
                    </div>
                  </div>
                </td>
                <td>
                  <button type="button" class="btn btn-info" (click)="viewActiveTrackingEvent($event, item)">
                    <i class="glyphicon glyphicon-info-sign"></i>
                  </button>
                </td>
                <td>
                  <button type="button" class="btn btn-danger" (click)="goLive($event, item)">
                    <i class="glyphicon glyphicon-globe"></i>
                  </button>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
  }

  @if (showDistress) {
    <div style="position: absolute;" id="distress" class="tab-pane fade show active">
      <div style="padding-bottom: 120px; padding-right: 10px;">
        <table class="table table-striped table-hover custom-table" style="padding-top: 10px;">
          <tbody>
            @for (item of distressed_tracking_items; track item) {
              <tr (click)="activeTrackingEventClick(item)">
                <td>
                  <div class="row">
                    <div class="col-lg-12">
                      <h4>{{ item.title }}</h4>
                      <p>{{ item.getFormattedDate() }}</p>
                    </div>
                  </div>
                </td>
                <td>
                  <button type="button" class="btn btn-info" (click)="viewActiveTrackingEvent($event, item)">
                    <i class="glyphicon glyphicon-info-sign"></i>
                  </button>
                </td>
                <td>
                  <button type="button" class="btn btn-danger" (click)="goLive($event, item)">
                    <i class="glyphicon glyphicon-globe"></i>
                  </button>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
  }
</div>
